jQuery(document).ready(function($){
    const $blocks = $('.wp-block-jormi-blocks-mega-menu');
    const $siteHeader = $('header.site-header');
    const $floatingElem = $siteHeader.find('.floating-header');
    
    if ($blocks.length === 0) return;
    
    $blocks.each(function() {
        const $block = $(this);        
        const blockSiblings = $block.siblings();
        const $headerElems = $siteHeader.find('.site-header-top, .wp-block-jormi-blocks-inline-logo, .overlay-trigger, .mega-menu-item').add(blockSiblings);
        const $overlay = $block.find('.mega-menu-overlay');
        const $offcanvas = $block.find('.custom-offcanvas');
        const $bgOverlay = $block.find('.bg-overlay');
        const $overlayTrigger = $block.find('.overlay-trigger');
        const $menuItems = $offcanvas.find('.mega-menu-item');
        
        /**
         * Mobile Offcanvas
         */
        if ($offcanvas.length > 0) {
            
            gsap.set($menuItems, {
                autoAlpha: 0,
                y: -16,
            });
            
            gsap.set($bgOverlay[0], {
                width: 0,
                height: 0,
            });
            
            // Get trigger center point
            function getTriggerCenter() {
                if ($overlayTrigger.length === 0) {
                    return {
                        x: window.innerWidth - 48,
                        y: 80
                    };
                }
                
                const triggerRect = $overlayTrigger[0].getBoundingClientRect();
                return {
                    x: triggerRect.left + (triggerRect.width / 2),
                    y: triggerRect.top + (triggerRect.height / 2)
                };
            }

            // Calculate required scale
            function getRequiredScale(centerX, centerY) {
                const maxDistanceX = Math.max(centerX, window.innerWidth - centerX);
                const maxDistanceY = Math.max(centerY, window.innerHeight - centerY);
                const maxDistance = Math.sqrt(maxDistanceX * maxDistanceX + maxDistanceY * maxDistanceY);
                
                const initialSize = 20;
                return (maxDistance * 2) / initialSize;
            }
            
            // Offcanvas open event
            function openOffcanvas() {
                // Prevent scroll
                $('html, body').addClass('overflow-hidden offcanvas-open');
                window.headerScrollDisabled = true;

                // Other header elements
                $headerElems.css({
                    'position': 'relative',
                    'z-index': '100'
                });

                // Update ARIA and trigger state
                $overlayTrigger.attr('aria-expanded', 'true');
                $offcanvas.attr('aria-hidden', 'false').addClass('active');

                // Add classes for CSS styling
                $siteHeader.addClass('mega-menu-open');
                $overlay.addClass('is-active');
                
                // Calculate animation params
                const triggerCenter = getTriggerCenter();
                const requiredScale = getRequiredScale(triggerCenter.x, triggerCenter.y);
                
                // Show offcanvas immediately
                gsap.set($offcanvas[0], { display: 'block', autoAlpha: 1 });
                
                // Position background overlay at trigger center
                $bgOverlay.css({
                    width: '20px',
                    height: '20px',
                    borderRadius: '50%',
                    left: (triggerCenter.x - 10) + 'px',
                    top: (triggerCenter.y - 10) + 'px',
                    right: 'auto'
                });
                
                /**
                 * Mobile Animation
                 */
                const tl = gsap.timeline({
                    defaults: { ease: 'power2.out' }
                });
                
                // 1. Expand background overlay
                tl.to($bgOverlay[0], {
                    duration: 0.6,
                    scale: requiredScale,
                    ease: 'power2.inOut',
                    transformOrigin: 'center center'
                })
                // 2. Stagger in menu items
                .to($menuItems, {
                    duration: 0.6,
                    autoAlpha: 1,
                    y: 0,
                    stagger: {
                        amount: 0.1,
                        from: "start",
                        ease: "power1.inOut"
                    }
                }, "-=0.2");
            }
            
            // Offcanvas close event
            function closeOffcanvas() {

                // Update ARIA and trigger state
                $overlayTrigger.attr('aria-expanded', 'false');
                
                const triggerCenter = getTriggerCenter();
                
                // Reverse tl
                const tl = gsap.timeline({
                    defaults: { ease: 'power2.inOut' },
                    onComplete: () => {
                        $('html, body').removeClass('overflow-hidden offcanvas-open');
                        window.headerScrollDisabled = false;
                        $headerElems.css({
                            'position': '',
                            'z-index': ''
                        });
                        $siteHeader.removeClass('mega-menu-open');
                        $overlay.removeClass('is-active');
                        $offcanvas.attr('aria-hidden', 'true').removeClass('active');
                        gsap.set($offcanvas[0], { display: 'none', autoAlpha: 0 });
                    }
                });
                
                // 1. Hide menu items
                tl.to($menuItems, {
                    duration: 0.2,
                    autoAlpha: 0,
                    y: -20,
                    stagger: {
                        amount: 0.1,
                        from: "end",
                        ease: "power2.in"
                    }
                })
                // 2. Shrink background overlay
                .to($bgOverlay[0], {
                    duration: 0.4,
                    scale: 0,
                    ease: 'power1.inOut',
                    onComplete: () => {
                        $bgOverlay.css({
                            width: 0,
                            height: 0,
                            left: 'auto',
                            top: 'auto',
                            right: '3rem',
                            borderRadius: '999px 0 999px 999px',
                            transform: 'scale(1)'
                        });
                    }
                }, "-=0.1");

                // Close all mega-menu-item accordions
                const $accordions = $offcanvas.find('.hs-accordion');
                $accordions.each(function() {
                    const $accordion = $(this);
                    const $toggle = $accordion.find('.hs-accordion-toggle');
                    if ($accordion.hasClass('active')) {                        
                        $toggle.trigger('click');
                    }
                });
            }
            
            // Trigger button click
            $overlayTrigger.on('click', function(e) {
                e.preventDefault();
                e.stopPropagation();
                
                const isOpen = $(this).attr('aria-expanded') === 'true';
                
                if (isOpen) {
                    closeOffcanvas();
                } else {
                    openOffcanvas();
                }
            });
            
            // Close overlay on outside click
            $(document).on('click', function(e) {
                if ($offcanvas.hasClass('active') && 
                    !$(e.target).closest('.custom-offcanvas, .overlay-trigger').length) {
                    closeOffcanvas();
                }
            });
            
            // Close on escape key
            $(document).on('keydown', function(e) {
                if (e.key === 'Escape' && $offcanvas.hasClass('active')) {
                    closeOffcanvas();
                }
            });

            /**
             * Handle resize
             * close menu on window resize
             */
            let resizeTimeout;
            $(window).on('resize', function(){
                clearTimeout(resizeTimeout);
                resizeTimeout = setTimeout(function() {
                    closeOffcanvas();
                    location.reload();
                }, 100)
            })
        }

        /**
         * DESKTOP MENU
         */
        if (window.matchMedia('(min-width: 1440px)').matches) {
            const $mainContentWrapper = $('.main-content-wrapper');

            // Get site header height and set content-item position
            const siteHeaderHeight = $siteHeader.outerHeight();
            
            // Initial state
            $('.content-item').each(function() {
                gsap.set(this, {
                    height: 0,
                    visibility: 'hidden',
                    top: siteHeaderHeight + 'px'
                });
            });

            // Update floating elem's border radius
            function updateFloatingBorderRadius(hasOpenDropdown) {
                if ($floatingElem.length > 0) {
                    gsap.to($floatingElem[0], {
                        borderBottomLeftRadius: hasOpenDropdown ? '0' : '1rem',
                        borderBottomRightRadius: hasOpenDropdown ? '0' : '1rem',
                        duration: 0.2,
                        ease: 'power2.out'
                    });
                }
            }

            // Function to check if any dropdown is open
            function hasAnyDropdownOpen() {
                return $('.nav-button[aria-expanded="true"]').length > 0;
            }

            $('.nav-button').on('click', function(e) {
                e.preventDefault();
                const $btn = $(this);
                const btnId = $btn.attr('id');
                const baseId = btnId.replace(/-trigger-\d+$/, '');
                const index = btnId.match(/-trigger-(\d+)$/)[1];
                const $target = $('#' + baseId + '-content-' + index)[0];
                const isOpen = $btn.attr('aria-expanded') === 'true';

                // Close all others and reset their icons
                $('.nav-button').not($btn).each(function() {
                    $(this).attr('aria-expanded', 'false');
                    gsap.to($(this).find('.trigger-icon')[0], {
                        rotation: 0,
                        duration: 0.2,
                        ease: 'power2.out'
                    });
                });
                
                $('.content-item').each(function() {
                    if (this !== $target) {
                        gsap.to(this, {
                            height: 0,
                            duration: 0.3,
                            ease: 'power2.inOut',
                            onComplete: () => {
                                this.setAttribute('aria-hidden', 'true');
                                gsap.set(this, { visibility: 'hidden' });
                            }
                        });
                    }
                });

                if (!isOpen) {
                    // OPENING: Show main wrapper and animate dropdown
                    $mainContentWrapper.css('display', 'block');
                    
                    // Update floating element border radius BEFORE dropdown animation
                    updateFloatingBorderRadius(true);
                    
                    // Rotate trigger icon for opening dropdown
                    gsap.to($btn.find('.trigger-icon')[0], {
                        rotation: 180,
                        duration: 0.2,
                        ease: 'power2.out'
                    });
                    
                    // Set button state
                    $btn.attr('aria-expanded', 'true');
                    
                    // Small delay to let border radius animation start first
                    setTimeout(() => {
                        // Make target visible for measurement but keep collapsed
                        gsap.set($target, { 
                            visibility: 'visible',
                            height: 'auto',
                            overflow: 'hidden'
                        });
                        
                        // Get natural height
                        const fullHeight = $target.scrollHeight;
                        
                        // Reset to collapsed state
                        gsap.set($target, { height: 0 });
                        
                        // Animate opening
                        gsap.to($target, {
                            height: fullHeight,
                            duration: 0.3,
                            ease: 'power3.out',
                            onStart: () => {
                                $target.setAttribute('aria-hidden', 'false');
                            },
                            onComplete: () => {
                                gsap.set($target, { height: 'auto' });
                            }
                        });
                    }, 150); // delay to let border radius start changing first
                    
                } else {
                    // CLOSING: Update button state first, then animate and hide wrapper
                    $btn.attr('aria-expanded', 'false');
                    
                    // Rotate trigger icon back when closing
                    gsap.to($btn.find('.trigger-icon')[0], {
                        rotation: 0,
                        duration: 0.2,
                        ease: 'power2.out'
                    });
                    
                    // Collapse target
                    gsap.to($target, {
                        height: 0,
                        duration: 0.3,
                        ease: 'power2.inOut',
                        onComplete: () => {
                            $target.setAttribute('aria-hidden', 'true');
                            gsap.set($target, { visibility: 'hidden' });
                            
                            // Check if any other dropdowns are still open
                            const stillHasOpenDropdown = hasAnyDropdownOpen();
                            
                            // Update floating element border radius
                            updateFloatingBorderRadius(stillHasOpenDropdown);
                            
                            // Hide main wrapper only if no dropdowns are open
                            if (!stillHasOpenDropdown) {
                                $mainContentWrapper.css('display', 'none');
                            }
                        }
                    });
                }
            });

            // Function to smoothly close all dropdowns with reverse timeline
            function closeAllDropdowns() {
                const $openButtons = $('.nav-button[aria-expanded="true"]');
                
                if ($openButtons.length === 0) return; // No dropdowns to close
                
                // Update all button states first
                $openButtons.attr('aria-expanded', 'false');
                
                // Reset all trigger icons
                $('.nav-button .trigger-icon').each(function() {
                    gsap.to(this, {
                        rotation: 0,
                        duration: 0.2,
                        ease: 'power2.out'
                    });
                });
                
                // Create staggered closing timeline for all open dropdowns
                const tl = gsap.timeline({
                    onComplete: () => {
                        // Reset floating element border radius and hide wrapper after all close
                        updateFloatingBorderRadius(false);
                        $mainContentWrapper.css('display', 'none');
                    }
                });
                
                // Animate all content items closing with slight stagger
                tl.to('.content-item', {
                    height: 0,
                    duration: 0.3,
                    ease: 'power2.inOut',
                    stagger: 0.05, // Slight stagger for visual appeal
                    onComplete: function() {
                        // This runs for each individual item
                        this.targets().forEach(target => {
                            target.setAttribute('aria-hidden', 'true');
                            gsap.set(target, { visibility: 'hidden' });
                        });
                    }
                });
            }

            // Outside click to close
            $(document).on('click', function(e) {
                if (!$(e.target).closest('.nav-button, .content-item').length) {
                    closeAllDropdowns();
                }
            });

            // Scroll detection to close dropdowns
            let scrollTimeout;
            $(window).on('scroll', function() {
                // Clear any existing timeout
                clearTimeout(scrollTimeout);
                
                // Only close if there are open dropdowns
                if (hasAnyDropdownOpen()) {
                    console.log('Closing dropdowns due to scroll');
                    closeAllDropdowns();
                }
            });

            // Keyboard support
            $(document).on('keydown', function(e) {
                if (e.key === 'Escape' || e.keyCode === 27) {
                    closeAllDropdowns();
                }
            });

            /**
             * Handle resize
             * close menu on window resize
             */
            let resizeTimeout;
            $(window).on('resize', function(){
                clearTimeout(resizeTimeout);
                resizeTimeout = setTimeout(function() {
                    closeAllDropdowns();
                    location.reload();
                }, 100)
            })
        }
    });
});